export const Chat = () => (
  <path
    d='M14 10.5C14 10.8536 13.8595 11.1928 13.6095 11.4428C13.3594 11.6929 13.0203 11.8333 12.6667 11.8333H4.66667L2 14.5V3.83333C2 3.47971 2.14048 3.14057 2.39052 2.89052C2.64057 2.64048 2.97971 2.5 3.33333 2.5H12.6667C13.0203 2.5 13.3594 2.64048 13.6095 2.89052C13.8595 3.14057 14 3.47971 14 3.83333V10.5Z'
    stroke='#246AAD'
    fill='none'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
)
